import Vue from "vue";
import {
  errorServeiceHandler,
  makeQueryStringDync,
  makeQueryFormDataDyn
} from "../../helper";
const state = {
  otpData: undefined
};
const getters = {
  getOtpData: state => {
    console.log("otp getter ", state.otpData);
    return state.otpData;
  }
};
const mutations = {
  setOtpData: (state, data) => {
    state.otpData = data;
    console.log("otp setter ", state.otpData);
  }
};
const actions = {
  actPostGenerateOtp: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/generateotp", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  actPostVerifyOtp: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/otpverify", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  actPostReGenerateOtp: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/regenotp", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  lazyPayReGenerateOtp: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/resendotp", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  lazyPayVerifyOtp: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/pay", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  lazyPaymentConfirm: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = payload
      fetch(context.getters.baseUrl + "/subscriber/paymentconfirm", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  cancelLazypayPayment: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/lazypay/updateCanclePayment", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  
};

export default {
  actions,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/account/otp.js